import { useEffect, useRef } from 'react';
import isEqual from 'react-fast-compare';
import { useSelector, useDispatch } from 'react-redux';
import { getThreadState } from '../../selectors';
import { streamIdChanged } from '../../actionCreators';
export function useThreadChanged(commentableItemId, commentableTypeId, parentId, enabled = true, maxDepthOverride) {
    const { isInitialized, order, streamId, maxDepth } = useSelector((state)=>getThreadState(state, commentableTypeId, commentableItemId, parentId), isEqual);
    const dispatch = useDispatch();
    const previousStreamId = useRef();
    useEffect(()=>{
        if (isInitialized || streamId === previousStreamId.current || !enabled) {
            return;
        }
        previousStreamId.current = streamId;
        dispatch(streamIdChanged({
            commentableItemId,
            commentableTypeId,
            parentId,
            order,
            streamId,
            maxDepth: maxDepthOverride !== null && maxDepthOverride !== void 0 ? maxDepthOverride : maxDepth
        }));
    }, [
        streamId,
        isInitialized,
        maxDepthOverride,
        commentableItemId,
        commentableTypeId,
        parentId,
        order,
        maxDepth,
        dispatch,
        enabled
    ]);
}
